"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: outdated
// const exampleBundleTemplate: Transport_CreateBundle = {
//   name: "Bundle 1",
//   categories: [
//     {
//       name: "sub",
//       isVisibleInMenu: true,
//       description: "blblbl",
//       logo: {
//         url: "https://www.google.com/qwe.png",
//         description: "This is a description",
//       },
//       createdAt: new Date(),
//       productsCount: 0,
//       parent: {
//         name: "parent",
//         isVisibleInMenu: true,
//         description: "blblbl",
//         logo: {
//           url: "https://www.google.com/qwe.png",
//           description: "This is a description",
//         },
//         createdAt: new Date(),
//         productsCount: 0,
//       },
//     },
//   ],
//   supplier: {
//     name: "Supplier 1",
//     email: "supplier@example.com",
//     dropshipping: false,
//     payeeAccounts: [],
//     createdAt: new Date(),
//     contacts: [],
//     currency: "GBP",
//   },
//   brand: {
//     createdAt: new Date(),
//     logo: {
//       url: "https://www.google.com/qwe.png",
//       description: "This is a description",
//     },
//     name: "Brand 1",
//     productsCount: 0,
//   },
//   publishedDate: new Date(),
//   status: ProductStatus.ACTIVE,
//   stockStatusSettings: {
//     high: 10,
//     low: 0,
//   },
//   items: [
//     {
//       productVariant: "60f7c0b8b4d1c8a1b8e4d2c3",
//       qty: 2,
//     },
//     {
//       productVariant: "60f7c0b8b4d1c8a1b8e4d2c4",
//       qty: 1,
//     },
//   ],
//   images: ["60f7c0b8b4d1c8a1b8e4d2c5"],
//   minOrderQty: 1,
//   maxOrderQty: 10,
//   pricing: {
//     GBP: {
//       price: "10.00",
//       priceWithVAT: "12.00",
//       VAT: 20,
//       isClientBasedPrice: false,
//       discounts: [],
//       compareAtRetailPrice: "15.00",
//       compareAtWholesalePrice: "13.00",
//     },
//   },
//   deliveryInfo: {
//     packagingItems: 1,
//     volume: "2",
//     volumeUnit: MeasurementUnits.LITRES,
//     deliveryTime: ProductDeliveryTime.DAYS_3_5,
//     weight: "2",
//     weightUnit: MeasurementUnits.KILOGRAMS,
//     height: "2",
//     heightUnit: MeasurementUnits.CENTIMETERS,
//     length: "2",
//     lengthUnit: MeasurementUnits.CENTIMETERS,
//     width: "2",
//     widthUnit: MeasurementUnits.CENTIMETERS,
//     postageCost: "0.50",
//     shippingCost: "1.20",
//   },
//   sku: "BUNDLE-123456",
//   inventoryInfo: {
//     qty: 10,
//     status: ProductStockStatus.HIGH,
//     soldCount: 0,
//     qtyBackordered: 0,
//     qtyAllocated: 0,
//     incomingQty: 0,
//   },
//   isSellable: true,
//   isTrackable: true,
//   allowListingOnMobile: true,
//   isSyncingDescription: true,
//   isSyncingImages: true,
//   isSyncingCategories: true,
//   createdAt: new Date(),
// };
